import React from 'react';
import paginationPrevious from '../assets/images/pagination-previous.svg';

export default () => {
  return <img src={paginationPrevious} alt="Previous Page" />;
};
